import { ApiError } from '../../api/client'
import type { CapacityRequest } from '../../api/capacity-requests'

export function errMsg(e: unknown): string {
  if (e instanceof ApiError) return e.message
  return e instanceof Error ? e.message : 'Something went wrong.'
}

export function effectivityLabel(r: CapacityRequest): string {
  if (r.isPermanent) return 'Permanent'
  return `${r.effectiveFrom ?? '?'} → ${r.effectiveTo ?? '?'}`
}

export function changeLabel(r: CapacityRequest): string {
  const parts: string[] = []
  if (r.newSlotPct != null) parts.push(`cap ${r.previousSlotPct ?? '—'}% → ${r.newSlotPct}%`)
  if (r.newFloor != null) parts.push(`floor ${r.previousFloor ?? '—'} → ${r.newFloor}`)
  return parts.join(' · ') || '—'
}

/** Today (local) as an ISO YYYY-MM-DD string, for comparing against windows. */
export function todayIso(): string {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

/**
 * The active temporary override for a team, if any — a non-permanent record
 * whose window contains today. Most-recently-recorded wins (the list arrives
 * newest-first). Returns null when the team has no active override.
 */
export function activeOverrideFor(
  teamId: string,
  requests: ReadonlyArray<CapacityRequest>,
): CapacityRequest | null {
  const today = todayIso()
  for (const r of requests) {
    if (
      r.teamId === teamId &&
      !r.isPermanent &&
      r.effectiveFrom != null &&
      r.effectiveTo != null &&
      r.effectiveFrom <= today &&
      today <= r.effectiveTo
    ) {
      return r
    }
  }
  return null
}
